import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 414.364 331.492',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="plane-arrival-solid" transform="translate(-213 -831.509)">
      <path
        fill={fill}
        id="plane-arrival-solid-2"
        data-name="plane-arrival-solid"
        d="M404,290.054H10.359A10.356,10.356,0,0,0,0,300.413v20.718a10.356,10.356,0,0,0,10.359,10.359H404a10.356,10.356,0,0,0,10.359-10.359V300.413A10.356,10.356,0,0,0,404,290.054ZM29.012,133.153l57.454,51.8a40.534,40.534,0,0,0,16.49,9.019l186.2,50.727c17.144,4.668,35.325,5.646,52.443.881,19.21-5.354,28.125-13.732,30.592-23.12s-1.12-21.178-15.131-35.583c-12.483-12.832-28.714-21.23-45.858-25.9l-63.132-17.2L183.1,19.565a10.76,10.76,0,0,0-7.549-7.711L133.406.375A10.692,10.692,0,0,0,120,11.019l31.025,106.317L84.854,99.311,66.991,55.363a10.707,10.707,0,0,0-7.135-6.429L34.133,41.922A10.7,10.7,0,0,0,20.718,52.2l.149,65.9c.123,5.769,3.9,11.227,8.145,15.053Z"
        transform="translate(213 831.51)"
      />
    </g>
  </svg>
);

export default SVG;
